// @flow

import React, { type Node } from 'react';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';

import { EftForm } from './eft';
import { AchPseForm } from './achpse';

export function PaymentMethodFields(): Node {
  const allFeatures = useCurrentAllFeatures();

  return (
    <>
      <EftForm allFeatures={allFeatures} />
      <AchPseForm allFeatures={allFeatures} />
    </>
  );
}
